import { useEffect } from "react";
import { useLocation, Link, useNavigate } from "react-router-dom";
import PropTypes from "prop-types";
import { useAuth } from "../../../context/AuthContext";

// @mui material components
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import Icon from "@mui/material/Icon";
import Typography from "@mui/material/Typography";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";

// Images
import Icon_ICTS from "../../../assets/images/icons/Icon_ICTS.png";
import Icon_CNA from "../../../assets/images/icons/Icon_CNA.png";
import Icon_CMAM from "../../../assets/images/icons/Icon_CMAM.png";

// Custom styles
import {
  navbar,
  navbarContainer,
  navbarIconButton,
} from "examples/Navbars/DashboardNavbar/styles";

// Material Dashboard 2 React context
import { useMaterialUIController, setTransparentNavbar } from "context";

function DashboardNavbar({ absolute, light, isMini }) {
  const [controller, dispatch] = useMaterialUIController();
  const { transparentNavbar, fixedNavbar, darkMode } = controller;
  const route = useLocation().pathname.split("/").slice(1);
  const navigate = useNavigate();
  const { user, setUser } = useAuth();

  useEffect(() => {
    const setNavbarType = (type) => {
      document.body.setAttribute("navbar-type", type);
    };
    setNavbarType(fixedNavbar ? "sticky" : "static");

    const handleTransparentNavbar = () => {
      setTransparentNavbar(dispatch, window.scrollY === 0 || !fixedNavbar);
    };

    window.addEventListener("scroll", handleTransparentNavbar);
    handleTransparentNavbar();

    return () => window.removeEventListener("scroll", handleTransparentNavbar);
  }, [dispatch, fixedNavbar]);

  const handleSignOut = () => {
    localStorage.removeItem("access_token");
    localStorage.removeItem("refresh_token");
    setUser(null);
    navigate("/authentication/sign-in");
  };

  const iconsStyle = ({
    palette: { dark, white, text },
    functions: { rgba },
  }) => ({
    fontSize: "2rem", // 🔹 Agranda los iconos
    color: () => {
      let colorValue = light || darkMode ? white.main : dark.main;
      if (transparentNavbar && !light)
        colorValue = darkMode ? rgba(text.main, 0.6) : text.main;
      return colorValue;
    },
  });

  return (
    <AppBar
      position={absolute ? "absolute" : "sticky"}
      color="inherit"
      sx={(theme) => ({
        ...navbar(theme, { transparentNavbar, absolute, light, darkMode }),
        backgroundColor: darkMode ? "#1e1e2f" : "#ffffffcc",
        border: "1px solid #e0e0e0",
        borderRadius: "8px",
        boxShadow: "none",
        backdropFilter: "blur(4px)",
      })}
    >
      <Toolbar sx={(theme) => navbarContainer(theme)}>
        <MDBox
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          width="100%"
        >
          {/* IZQUIERDA */}
          <MDBox display="flex" alignItems="center" gap={1}>
            <Link to="/proposals">
              <IconButton size="large">
                <Icon sx={iconsStyle}>home</Icon>
              </IconButton>
            </Link>
          </MDBox>
          {/* <MDBox
            display="flex"
            justifyContent="center"
            alignItems="center"
            gap={3}
            pt={1}
          >
            <img
                src={Icon_ICTS}
                alt="ICTS"
                style={{
                  width: "12%",
                  marginBottom: "10px",
                }}
              /> 

            <img
              src={Icon_CNA}
              alt="CNA"
              style={{
                width: "25%",
                marginBottom: "10px",
              }}
            />

            <img
              src={Icon_CMAM}
              alt="CMAM"
              style={{
                width: "23%",
                marginBottom: "10px",
              }}
            />
          </MDBox> */}

          {/* CENTRO: TÍTULO */}
          <MDBox display="flex" alignItems="center" justifyContent="center">
            <Typography
              variant="h6"
              sx={{
                fontWeight: "bold",
                fontSize: "1.5rem",
                color: darkMode ? "#fff" : "#333",
              }}
            >
              IABA-ICTS Metadata Portal
            </Typography>
          </MDBox>

          {/* DERECHA */}
          <MDBox display="flex" alignItems="center" gap={2}>
            <Link to="/profile">
              <IconButton size="large">
                <Icon sx={iconsStyle}>account_circle</Icon>
              </IconButton>
            </Link>
            {user && <span>{user.username}</span>}
            <MDButton
              variant="gradient"
              color="error"
              size="small"
              onClick={handleSignOut}
              sx={{ padding: "6px 16px" }}
            >
              Sign Out
            </MDButton>
          </MDBox>
        </MDBox>
      </Toolbar>
    </AppBar>
  );
}

// Default props
DashboardNavbar.defaultProps = {
  absolute: false,
  light: false,
  isMini: false,
};

DashboardNavbar.propTypes = {
  absolute: PropTypes.bool,
  light: PropTypes.bool,
  isMini: PropTypes.bool,
};

export default DashboardNavbar;
